import $ from 'jquery';

const $form = $('#id_question_form');

if ($form.length) {
    window.ymaps.ready(() => {
        new window.ymaps.SuggestView('id_address');
    });
}

$form.validate();



// WEBPACK FOOTER //
// ./js/home/form.js